import { createContext, useContext } from 'react'
import '@vp/pricing-context-module'
import type { PricingContextModule } from 'app/features/FragmentRoot/contexts/pricing/interface'

export const PricingContext = createContext<PricingContextModule.PcxtV3 | null>(null)

export const usePricingContext = () => useContext(PricingContext)
